import request from '@/utils/request'

export function login(username, password) {
  return request({
    url: '/ctr-admin/admin/login',
    method: 'post',
    data: {
      username,
      password
    }
  })
}

export function getInfo() {
  return request({
    url: '/ctr-admin/admin/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/ctr-admin/admin/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/ctr-admin/admin/list',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/ctr-admin/admin/register',
    method: 'post',
    data: data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: '/ctr-admin/admin/update/' + id,
    method: 'post',
    data: data
  })
}

export function setPassword(id, newPassword) {
  return request({
    url: '/ctr-admin/admin/setPassword',
    method: 'post',
    data: {
      id,
      newPassword
    }
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/ctr-admin/admin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}

export function deleteAdmin(id) {
  return request({
    url: '/ctr-admin/admin/delete/' + id,
    method: 'post'
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/ctr-admin/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/ctr-admin/admin/role/update',
    method: 'post',
    data
  })
}

export function changePsd(data) {
  return request({
    url: '/ctr-admin/admin/updatePassword',
    method: 'post',
    data
  })
}


export function getRegionMember(params) {
  return request({
    url: '/ctr-admin/admin/regionMember',
    method: 'get',
    params:params
  })
}




// WEBPACK FOOTER //
// ./src/api/login.js